// extracted by mini-css-extract-plugin
export default {"root":"E0p7gF","date":"wVqMnO","name":"ZbujfJ","mobile":"ku8q1G","mobileDateContainer":"EEjMhf","tbdDate":"NiH6bh","mobileDate":"sCjO6e"};